export default {
  baseStyle: {
    fontWeight: 'normal',
    borderRadius: 2,
    borderWidth: 1,
    height: '40px',
  },
}
